module.exports = __webpack_public_path__ + "img/kp.ee0ba2fe.svg";